module.exports = __webpack_public_path__ + "img/dga.8a4f6463.svg";